import { Controller } from "@hotwired/stimulus";

// Tracks the referral share surface (_track.html.haml): the QR download and
// the LinkedIn/X/email share channels. Link copying is instrumented
// separately in clipboard_copy_controller.js. Wire by adding
// data-controller="referral-track" to the track's root element with
// program-type-value set from the program being shared.
export default class extends Controller {
  static values = {
    programType: String,
  };

  qrDownloaded() {
    this.capture("referral_qr_downloaded");
  }

  channelClicked(event) {
    this.capture("referral_share_channel_clicked", {
      channel: event.params.channel,
    });
  }

  capture(eventName, props = {}) {
    if (typeof window.posthog === "undefined") return;
    window.posthog.capture(eventName, {
      program_type: this.programTypeValue,
      ...props,
    });
  }
}
